import { Easing, Tween } from '@tweenjs/tween.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import AnimateEntrance from '../helper/animate';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { getCurrencySymbol } from '../helper/currencies';
import HELPERS from '../../lib/globals/helpers/Helpers';

class QuestPromptController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.interaction = true;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
		this.win = 0;
		if (vc[this.config.holder]) {
			this.vc = vc[this.config.holder];
			AnimateEntrance(this.vc.parent);
			this.vc.QUEST_PROMPT_PRIZE.text = this.win;
			this.vc.QUEST_PROMPT_YES.handler = this.handler.bind(this);
			this.totalWin = GameConfigs.quest_current.win;
			// this.totalWin = 0;

			this.updateWin(this.totalWin);
			this.vc.QUEST_PROMPT_AMOUNT.alpha = 0;
			this.vc.QUEST_PROMPT_AMOUNT.scale.set(4);
			// setTimeout(() => {
			//   if (GameConfigs.settings.keyboard_shortcuts && !window.isMobile && !window.isTablet) {
			//     window.addEventListener("keydown", this, false);
			//   }
			//   window.addEventListener(EVENTS.INTERACTION, this, false);
			// }, 1000);
		} else {
			throw new Error(
				'QuestPromptController failed init ' + JSON.stringify(this.config)
			);
		}
	}
	handler() {
		HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
			quest_claim: {
				...GameConfigs.quest_claim,
				claimed: true,
				activated: true,
				activated_item: 0,
				item: null,
				status: ''
			}
		});
		if (GameConfigs.autospin.isAutoOn) {
			HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
				numOfBets: GameConfigs.autospin.numOfBets,
				isAutoOn: false,
				leftBets: 0,
				pause: false
			});
		}
		GameConfigs.quest_current = null;
		GameConfigs.quest_is_active = false;
		window.removeEventListener(EVENTS.INTERACTION, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener('keydown', this, false);
		if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
			GameConfigs.uiComponent.removeView(
				GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
			);
		}
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		HELPERS.disableAllButtons(false);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.INTERACTION:
				// this.handler();
				break;
			case EVENTS.MODAL:
				if (evt.detail.modal !== 'quest_prompt') {
					this.handler();
				}
				break;
			case 'keydown':
				if (
					(evt.keyCode === 27 ||
						(evt.keyCode === 32 && !GameConfigs.disabled.spin)) &&
					GameConfigs.modal !== 'fastplay_dialogue'
				) {
					this.handler();
				}
				break;
			default:
				break;
		}
	}

	setWin() {
		if (this.currency[1] === 'left') {
			this.vc.QUEST_PROMPT_PRIZE.text =
				this.currency[0] +
				(+this.win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				});
		} else {
			this.vc.QUEST_PROMPT_PRIZE.text =
				(+this.win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				}) + this.currency[0];
		}
	}

	updateWin(a) {
		this.tweener = new Tween(this)
			.to({ win: a }, 1000)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin();
			})
			.start()
			.onComplete(() => {
				this.vc.QUEST_PROMPT_AMOUNT.alpha = 1;
				new Tween(this.vc.QUEST_PROMPT_AMOUNT.scale)
					.to({ x: 1, y: 1 }, 150)
					.easing(Easing.Linear.None)
					.start();
			});
	}
}
export default QuestPromptController;
